module.exports = __webpack_public_path__ + "img/login_code.53ce199f.png";